/* cali free-shipping bar
 * Reads the EUR threshold for the visitor's country from #CaliFsConfig,
 * converts it to the presentment currency via Shopify.currency.rate, and
 * keeps the announcement line + cart-drawer progress bar in sync with the
 * cart (Motion's `cart:updated` event + /cart.js fetches).
 */
(function () {
  'use strict';

  // Dismissible top bar: collapse on ✕ and stay closed for this visit.
  // cali 2026-09-30 ship-to line: bound before the config checks, because the
  // "We ship to" line has no threshold and no #CaliFsConfig but closes too.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-cali-fs-close]');
    if (!btn) return;
    var bar = btn.closest('.cali-fs-bar');
    if (!bar) return;
    bar.classList.add('is-closed');
    try {
      sessionStorage.setItem('caliFsBarClosed', '1');
    } catch (err) {}
  });

  function setMessage(el, text) {
    if (el.textContent === text) return;
    el.classList.remove('is-in');
    el.textContent = text;
    // Force a reflow so the rise-in transition replays on each swap.
    void el.offsetWidth;
    el.classList.add('is-in');
  }

  // cali 2026-11-01 offer bar: while the cart is empty, the top line takes
  // turns with the offers in #CaliBarOffers (theme setting "Offer taking turns
  // with the top line"), each shown on the offer colours, the background
  // crossfading between them. Paused while hovered or focused; stopped once the
  // cart has something in it (the delivery progress matters more then) and when
  // the bar is closed. Visitors who ask for less motion get the first offer,
  // still. Turns are not announced: the bar is a live region only while still.
  var OFFER_FIRST_MS = 3000; // TODO(v2): expose as a setting
  var OFFER_EACH_MS = 4500; // TODO(v2): expose as a setting
  var SWAP_MS = 300; // the .cali-fs__msg fade

  var offers = [];
  (function () {
    var el = document.getElementById('CaliBarOffers');
    if (!el) return;
    try {
      (JSON.parse(el.textContent).messages || []).forEach(function (m) {
        if (m && m.text) offers.push({ key: m.key || '', text: m.text, href: m.href || '', offer: true });
      });
    } catch (err) {}
  })();

  var reduceMotion = !!(
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  var rot = { bar: null, items: [], index: 0, timer: 0, hold: false, on: false, run: 0 };

  function barHidden(bar) {
    return bar.classList.contains('is-closed') || bar.style.display === 'none';
  }

  function paintLine(bar, item) {
    var msg = bar.querySelector('.cali-fs__msg');
    if (!msg) return;
    msg.textContent = '';
    if (item.href) {
      var link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.text;
      link.setAttribute('data-cali-bar-offer', item.key);
      msg.appendChild(link);
    } else {
      msg.textContent = item.text;
    }
    bar.classList.toggle('is-offer', !!item.offer);
  }

  function swapLine(bar, item) {
    var msg = bar.querySelector('.cali-fs__msg');
    if (!msg) return;
    msg.classList.remove('is-in');
    var run = rot.run;
    window.setTimeout(function () {
      if (run !== rot.run) return; // the turns stopped during the fade
      paintLine(bar, item);
      void msg.offsetWidth;
      msg.classList.add('is-in');
    }, reduceMotion ? 0 : SWAP_MS);
  }

  function quiet(bar, yes) {
    // role="status" makes the bar a polite live region; each turn would be read out.
    var msg = bar.querySelector('.cali-fs__msg');
    if (yes) {
      bar.setAttribute('aria-live', 'off');
      if (msg && msg.hasAttribute('aria-live')) msg.setAttribute('aria-live', 'off');
    } else {
      bar.removeAttribute('aria-live');
      if (msg && msg.hasAttribute('aria-live')) msg.setAttribute('aria-live', 'polite');
    }
  }

  function nextTurn() {
    rot.timer = 0;
    if (!rot.on) return;
    if (barHidden(rot.bar)) {
      rot.on = false;
      return;
    }
    if (!rot.hold) {
      rot.index = (rot.index + 1) % rot.items.length;
      swapLine(rot.bar, rot.items[rot.index]);
    }
    rot.timer = window.setTimeout(nextTurn, OFFER_EACH_MS);
  }

  function stopTurns(bar) {
    window.clearTimeout(rot.timer);
    rot.timer = 0;
    rot.on = false;
    rot.run += 1;
    bar.classList.remove('is-offer');
    quiet(bar, false);
  }

  function holdTurns(bar) {
    if (bar.hasAttribute('data-cali-bar-turns')) return;
    bar.setAttribute('data-cali-bar-turns', '');
    bar.addEventListener('mouseenter', function () { rot.hold = true; });
    bar.addEventListener('mouseleave', function () { rot.hold = false; });
    bar.addEventListener('focusin', function () { rot.hold = true; });
    bar.addEventListener('focusout', function () { rot.hold = false; });
    bar.addEventListener('click', function (evt) {
      var link = evt.target.closest && evt.target.closest('[data-cali-bar-offer]');
      if (!link) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'cali_bar_offer_click',
          bar_offer: link.getAttribute('data-cali-bar-offer')
        });
      } catch (err) {}
    });
  }

  // The top line's own text, and whether the offers may take turns with it.
  function barLine(bar, text, turns) {
    var msg = bar.querySelector('.cali-fs__msg');
    if (!msg) return;
    if (!turns || !offers.length) {
      if (rot.bar === bar && (rot.on || bar.classList.contains('is-offer'))) {
        stopTurns(bar);
        msg.textContent = '';
      }
      setMessage(msg, text);
      return;
    }
    holdTurns(bar);
    rot.bar = bar;
    if (reduceMotion) {
      quiet(bar, false);
      if (msg.textContent !== offers[0].text) paintLine(bar, offers[0]);
      msg.classList.add('is-in');
      return;
    }
    var base = { key: '', text: text, href: '', offer: false };
    if (rot.on) {
      // A cart refresh on the still-empty cart: keep the turns going.
      if (rot.items[0].text !== text) {
        rot.items[0] = base;
        if (rot.index === 0) swapLine(bar, base);
      }
      return;
    }
    rot.items = [base].concat(offers);
    rot.index = 0;
    rot.on = true;
    quiet(bar, true);
    if (msg.textContent !== text || bar.classList.contains('is-offer')) {
      bar.classList.remove('is-offer');
      setMessage(msg, text);
    }
    rot.timer = window.setTimeout(nextTurn, OFFER_FIRST_MS);
  }

  // The "We ship to" line has no #CaliFsConfig: its turns start here.
  var shipTo = document.querySelector('.cali-fs-bar--ship-to');
  if (shipTo && !barHidden(shipTo)) {
    var shipMsg = shipTo.querySelector('.cali-fs__msg');
    if (shipMsg) barLine(shipTo, shipMsg.textContent, true);
  }

  var cfgEl = document.getElementById('CaliFsConfig');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (err) {
    return;
  }

  var thresholdEur = cfg.thresholds && cfg.thresholds[cfg.country];
  if (!thresholdEur || thresholdEur <= 0) return;

  // Displayed thresholds round UP to a clean local amount (never below the
  // real EUR checkout rule, so "unlocked" is always true at checkout too).
  var ROUND_STEP = { JPY: 1000, KRW: 1000, TWD: 100 };
  var wasUnlocked = null;

  var flag =
    cfg.country && cfg.country.length === 2
      ? String.fromCodePoint(
          0x1f1e6 + cfg.country.charCodeAt(0) - 65,
          0x1f1e6 + cfg.country.charCodeAt(1) - 65
        )
      : '';

  function currencyInfo() {
    var shopify = window.Shopify || {};
    var cur = shopify.currency || {};
    return {
      code: cur.active || cfg.shopCurrency || 'EUR',
      rate: parseFloat(cur.rate) || 1
    };
  }

  function thresholdCents(cur) {
    var raw = thresholdEur * 100 * cur.rate;
    var step = (ROUND_STEP[cur.code] || 10) * 100;
    return Math.ceil(raw / step) * step;
  }

  // Currencies where the site's own price rendering differs from Intl's
  // narrow symbol — mirror the storefront exactly (minus the decimals).
  var CUSTOM_FORMAT = { AED: 'Dhs. {n}', SAR: '{n} SR', CHF: 'CHF {n}.–' };

  function formatMoney(cents, cur) {
    var units = Math.round(cents / 100);
    var custom = CUSTOM_FORMAT[cur.code];
    if (custom) {
      var grouped;
      try {
        grouped = units.toLocaleString(cfg.locale || 'en');
      } catch (err) {
        grouped = String(units);
      }
      return custom.replace('{n}', grouped);
    }
    var opts = {
      style: 'currency',
      currency: cur.code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    };
    try {
      return new Intl.NumberFormat(
        cfg.locale || 'en',
        Object.assign({ currencyDisplay: 'narrowSymbol' }, opts)
      ).format(units);
    } catch (err) {
      try {
        return new Intl.NumberFormat(cfg.locale || 'en', opts).format(units);
      } catch (err2) {
        return cur.code + ' ' + units;
      }
    }
  }

  function template(name, vars) {
    var text = (cfg.messages && cfg.messages[name]) || '';
    return text.replace(/\{(amount|remaining)\}/g, function (match, key) {
      return vars[key] != null ? vars[key] : match;
    });
  }

  function render(totalCents) {
    var roots = document.querySelectorAll('[data-cali-fs]');
    if (!roots.length) return;

    var cur = currencyInfo();
    var goal = thresholdCents(cur);
    var unlocked = totalCents >= goal;
    var empty = totalCents <= 0;
    var pct = Math.max(0, Math.min(100, (totalCents / goal) * 100));

    var remaining = goal - totalCents;
    remaining = Math.ceil(remaining / 100) * 100;

    var text;
    if (unlocked) {
      text = template('unlocked', {});
    } else if (empty) {
      text = template('empty', { amount: formatMoney(goal, cur) });
    } else {
      text = template('progress', { remaining: formatMoney(remaining, cur) });
    }

    var justUnlocked = unlocked && wasUnlocked === false;
    wasUnlocked = unlocked;

    Array.prototype.forEach.call(roots, function (root) {
      root.classList.toggle('cali-fs--unlocked', unlocked);
      root.classList.toggle('cali-fs--empty', empty);
      root.classList.toggle('cali-fs--progress', !unlocked && !empty);

      var msg = root.querySelector('[data-cali-fs-message]');
      if (msg) {
        if (root.classList.contains('cali-fs-bar')) {
          barLine(root, flag ? flag + ' ' + text : text, empty);
        } else {
          setMessage(msg, text);
        }
      }

      var track = root.querySelector('[data-cali-fs-track]');
      if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));

      var fill = root.querySelector('[data-cali-fs-fill]');
      if (fill) fill.style.width = pct + '%';

      if (justUnlocked) {
        root.classList.add('cali-fs--just-unlocked');
        window.setTimeout(function () {
          root.classList.remove('cali-fs--just-unlocked');
        }, 700);
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          render(cart.total_price);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      render(cart.total_price);
    } else {
      refresh();
    }
  });

  // Motion fires ajaxProduct:added (not cart:updated) on add-to-cart.
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('cart:open', refresh);

  // Safety net for cart mutations made outside Motion's events
  // (third-party apps posting to /cart/add, /cart/change, /cart/update).
  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) {
        promise.then(function () {
          window.setTimeout(refresh, 50);
        }, function () {});
      }
      return promise;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && CART_MUTATION.test(String(url))) {
      this.addEventListener('load', function () {
        window.setTimeout(refresh, 50);
      });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
